// @flow
import * as React from 'react';
import RegenerateToken from './RegenerateToken';
import { connect } from 'react-redux';
import { redirectToAuthService } from 'ducks/auth-context';

export class RedirectToAuthService extends React.Component<*> {
  componentDidMount() {
    redirectToAuthService();
  }

  render() {
    return null;
  }
}

type CheckAuthenticationProps = {
  loginRequired: boolean,
  tokenRequired: boolean,
  children: React.Node,
};

export const CheckAuthentication = (props: CheckAuthenticationProps) => {
  const { loginRequired, tokenRequired, children } = props;

  if (loginRequired === true) {
    return <RedirectToAuthService />;
  } else if (tokenRequired === true) {
    return <RegenerateToken />;
  }

  return children;
};

const mapStateToProps = state => {
  const { auth } = state;

  return {
    loginRequired: auth.needsLogin(),
    tokenRequired: auth.needsTokenRefresh(),
  };
};

// $FlowFixMe
export default connect(mapStateToProps)(CheckAuthentication);



// WEBPACK FOOTER //
// ./src/pages/__components__/CheckAuthentication.js